package com.tixforgigs.common.ui.components.templateConfigurator

import com.tixforgigs.apax.models.FilterSearchResponse
import com.tixforgigs.apax.models.FilterSearchType
import com.tixforgigs.apax.models.TemplateData
import com.tixforgigs.apax.models.TemplateFilter
import com.tixforgigs.common.core.annotations.MissingTaramiIconKey
import com.tixforgigs.common.core.annotations.MissingTaramiMessageKey
import com.tixforgigs.common.core.enums.MandarinCheckboxType
import com.tixforgigs.common.core.models.ui.InputState
import com.tixforgigs.common.http.ApiGetPath
import com.tixforgigs.common.http.HttpClient.apiV4Get
import com.tixforgigs.common.ui.components.forms.templateSearchField
import com.tixforgigs.common.ui.components.grid.gridContainer
import com.tixforgigs.common.ui.components.mandarin.mandarinCheckbox
import com.tixforgigs.common.ui.components.mandarin.mandarinHeadline
import io.kvision.core.Container
import io.kvision.material.ExperimentalMaterialApi
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.update
import kotlin.time.ExperimentalTime

@OptIn(ExperimentalMaterialApi::class, ExperimentalTime::class)
fun Container.defaultTemplateOptions(
  templateState: MutableStateFlow<TemplateData?>,
  filterState: MutableStateFlow<TemplateFilter?>
) {
  gridContainer {
    gridItem(12) {
      gridContainer().bind(templateState) { template ->
        gridItem(12) {
          @MissingTaramiMessageKey
          mandarinHeadline(subheadline = "Allgemeine Einstellungen")
        }
        template?.let { data ->
          data.searchEnabled.let { searchEnabled ->
            gridItem(4) {
              val checkboxState = MutableStateFlow(InputState(searchEnabled, true))
              mandarinCheckbox<Unit>(
                state = checkboxState,
                checkboxType = MandarinCheckboxType.TEMPLATE_CONFIG_SEARCH_ENABLED
              ) {
                templateState.update { it?.copy(searchEnabled = checkboxState.value.inputValue) }
              }
            }
          }
          data.detailsDescriptionVisible.let { detailsDescriptionVisible ->
            gridItem(4) {
              val checkboxState = MutableStateFlow(InputState(detailsDescriptionVisible, true))
              mandarinCheckbox<Unit>(
                state = checkboxState,
                checkboxType = MandarinCheckboxType.TEMPLATE_CONFIG_DETAIL_DESCRIPTION_ENABLED
              ) {
                templateState.update { it?.copy(detailsDescriptionVisible = checkboxState.value.inputValue) }
              }
            }
          }
        }
      }
    }
    gridItem(12) {
      gridContainer().bind(filterState) { filter ->
        filter?.let { data ->
          gridItem(6) {
            @MissingTaramiMessageKey
            @MissingTaramiIconKey
            templateSearchField(
              inputLabel = "ausgeschlossene Events",
              initialSelectedItems = data.excludedEvents,
              inputLeadingIcon = "playlist_remove",
              itemLabel = { it.text },
              onUpdateSelectedItems = { items -> filterState.update { it?.copy(excludedEvents = items) } },
            ) { input ->
              if (input.length >= 3) {
                apiV4Get<FilterSearchResponse>(
                  type = ApiGetPath.TemplateFilterSearch(
                    searchText = input,
                    searchType = FilterSearchType.EVENT
                  )
                )?.filterItems.orEmpty()
              } else emptyList()
            }
          }
          gridItem(6) {
            @MissingTaramiMessageKey
            @MissingTaramiIconKey
            templateSearchField(
              inputLabel = "Künstler",
              initialSelectedItems = data.artists,
              inputLeadingIcon = "artist",
              itemLabel = { it.text },
              onUpdateSelectedItems = { items -> filterState.update { it?.copy(artists = items) } },
            ) { input ->
              if (input.length >= 3) {
                apiV4Get<FilterSearchResponse>(
                  type = ApiGetPath.TemplateFilterSearch(
                    searchText = input,
                    searchType = FilterSearchType.ARTIST
                  )
                )?.filterItems.orEmpty()
              } else emptyList()
            }
          }
          gridItem(6) {
            @MissingTaramiMessageKey
            @MissingTaramiIconKey
            templateSearchField(
              inputLabel = "Genres",
              initialSelectedItems = data.genres,
              inputLeadingIcon = "genres",
              itemLabel = { it.text },
              onUpdateSelectedItems = { items -> filterState.update { it?.copy(genres = items) } },
            ) { input ->
              if (input.length >= 3) {
                apiV4Get<FilterSearchResponse>(
                  type = ApiGetPath.TemplateFilterSearch(
                    searchText = input,
                    searchType = FilterSearchType.GENRE
                  )
                )?.filterItems.orEmpty()
              } else emptyList()
            }
          }
          gridItem(6) {
            @MissingTaramiMessageKey
            @MissingTaramiIconKey
            templateSearchField(
              inputLabel = "Locations",
              initialSelectedItems = data.venues,
              inputLeadingIcon = "location_on",
              itemLabel = { it.text },
              onUpdateSelectedItems = { items -> filterState.update { it?.copy(venues = items) } },
            ) { input ->
              if (input.length >= 3) {
                apiV4Get<FilterSearchResponse>(
                  type = ApiGetPath.TemplateFilterSearch(
                    searchText = input,
                    searchType = FilterSearchType.VENUE
                  )
                )?.filterItems.orEmpty()
              } else emptyList()
            }
          }
        }
      }
    }
  }
}